import ApiService from '../api.service'

const TazApiService = {
 
    // ----------------- Table MapSavedMap
    getGpoContractDetailDataForApiCall: async (id) => {
        const url = `/api/GpoApi/getGpoContractDetailDataForApiCall?id=${id}`

        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },

    // ----------------- END Table MapSavedMap
}

export default TazApiService